<div>
  <div class="w-[100%] flex justify-start ml-[8.1rem] mb-[5px]">
    <div class="flex justify-start">
      <div
        class="ml-[12px] bg-[#f9dacf] px-[6px] pt-[4px] pb-[4px] rounded-[50%] flex justify-end items-center"
      >
        <img
          src="assets/icons/close.svg"
          alt="close"
          class="cursor-pointer w-[14px]"
          (click)="cancel()"
        />
      </div>
      <div class="ml-[12px] bg-[#f9dacf] p-[4px] rounded-[50%]">
        <img
          src="assets/icons/save.svg"
          alt="save"
          class="cursor-pointer w-[18px] mr-[2px]"
          (click)="save()"
        />
      </div>
    </div>
  </div>
  <div class="mb-4">
    <!-- <input
      #inputField
      matInput
      placeholder="Enter key deliverable"
      (keydown.enter)="addKeyDeliverable(inputField)"
      class="p-2 border w-[308px] h-[44px] section-input"
    /> -->
    <mat-form-field appearance="outline">
      <mat-label>Enter key deliverable</mat-label>
      <input
        #inputField
        matInput
        (keydown.enter)="addKeyDeliverable(inputField)"
        class="section-input"
      />
    </mat-form-field>
    

    <div class="mt-[25px]">
      <ul>
        <div *ngFor="let deliverable of keyDeliverable" class="flex">
          <div
            class="flex"
            style="border-radius: 3px; border: 2px solid #eff8ff"
          >
            <span
              class="ml-[] h-[22px] mr-[10px]"
              style="border-radius: 3px; border: 1px #eff8ff"
              >{{ deliverable.name }}</span
            >
            <button
              type="button"
              class="justify-start"
              (click)="removekeyDeliverable(deliverable)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 12 12"
                fill="none"
                style="margin-top: 3px"
              >
                <g filter="url(#filter0_d_4054_30471)">
                  <ellipse
                    cx="5.7573"
                    cy="3.99989"
                    rx="3.7573"
                    ry="3.99989"
                    fill="white"
                  />
                  <path
                    d="M9.01461 3.99989C9.01461 5.96276 7.52726 7.49978 5.7573 7.49978C3.98735 7.49978 2.5 5.96276 2.5 3.99989C2.5 2.03702 3.98735 0.5 5.7573 0.5C7.52726 0.5 9.01461 2.03702 9.01461 3.99989Z"
                    stroke="#AAD4F5"
                    stroke-opacity="0.15"
                  />
                </g>
                <path
                  d="M4.31152 5.53875L7.20176 2.46191M4.31152 2.46191L7.20176 5.53875"
                  stroke="#868E96"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <defs>
                  <filter
                    id="filter0_d_4054_30471"
                    x="0"
                    y="0"
                    width="11.5146"
                    height="12"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="1" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_4054_30471"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_4054_30471"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </button>
          </div>
        </div>
      </ul>
    </div>
  </div>
</div>
